module.exports = __webpack_public_path__ + "static/media/Carrot Mascot.cf709f22.jpg";